module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/sell-property-small.8068e912437e5a341d4a3e5e0b319a77.jpg";